import { render, staticRenderFns } from "./coa-reports.vue?vue&type=template&id=67889778"
import script from "./coa-reports.vue?vue&type=script&lang=js"
export * from "./coa-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports